module.exports = {
  PROCESSING_SCHEMA: require('./processingSchema').default
}
